import { Fragment, useContext, useRef, useState } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { formatNum, uuid } from "../../../../oscar-pos-core/constants";
import { Box, capitalize, CircularProgress } from "@mui/material";
import { ListTableAmountCell, PopoverMenu, ReceiptPage } from "../../../common";
import amountCellStyles from "../../../common/ListTableAmountCell/styles.module.css";
import {
  BlackCheckIcon,
  DeleteNewIcon,
  DownloadIcon,
  EditIcon,
} from "../../../../assets/icons/icon";
import { useAuthContext } from "../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  bulkDeleteOrders,
  bulkRestoreStock,
} from "../../../../database/helpers/orders";
import { bulkDeleteInventory } from "../../../../database/helpers/inventory";
import {
  bulkCreatePayments,
  bulkDeletePaymentsV2,
  getPaymentsByInvoiceExternal,
} from "../../../../database/helpers/payment";
import {
  calculateTotalOutstanding,
  findCustomerByID,
} from "../../../../database/helpers/customer";
import { Sync } from "../../../../SyncService";
import { useSnackbar } from "../../../../context/SnackbarContext";
import withObservables from "@nozbe/with-observables";
import { handleDownloadInvoice } from "../../../Features/NewInvoiceBook/invoiceBookUtils";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { catchError, of } from "rxjs";
import { findCompanyByID } from "../../../../database/helpers/company";
import SidebarBodyContent from "../../../common/UBRightSidebar/SidebarBodyContent";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import RecordPaymentModal from "../../../common/Modals/RecordPaymentModal";
import AddContactSelector from "../../../common/AddContactSelector";
import { sentenceCase } from "../../../../constants";
import { useWalletContext } from "../../../../context/WalletContext";
import { dateFormatInNumberWithSpace, resolveCategoryDisplayName } from "../../../../utils";
import AttachContactMessage from "../../../common/AttachContactMessage";

const ItemList = ({
  expense,
  key,
  index,
  orders,
  customerDetail,
  selectedContactId,
  setSelectedContactId,
  justClosedDropdownRef,
  isAccountLoading,
  selectedId,
  onEdit = () => {},
  refetchList = () => {},
  contactList,
  handleSendMoney = () => {},
}) => {
  const addedCustomer = customerDetail || undefined;
  const [I18n] = useContext(LanguageContext);
  const { EMIVerified } = useWalletContext();
  const [openDetailSidebar, setOpenDetailSidebar] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user, business } = useAuthContext();
  const navigate = useNavigate();
  const componentRef = useRef(); // To reference the content to print
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpenRecordPaymentModal, setIsOpenRecordPaymentModal] =
    useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [recordPaymentObj, setRecordPaymentObj] = useState({
    customer: customerDetail
      ? {
          id: customerDetail.id,
          label: customerDetail.name,
          value: customerDetail.name,
        }
      : null,
  });
  const [isLoadingRecordPayment, setIsLoadingRecordPayment] = useState(false);

  const { showSnackbar } = useSnackbar();

  const handleDownload = () => {
    setIsLoading(true);
    handleDownloadInvoice(
      expense,
      business,
      (error) => {
        if (error) {
          if (!user?.phone_number) {
            showSnackbar({
              message: I18n.report_download_is_not_available_yet,
              severity: "error",
            });
          } else {
            showSnackbar({
              message: I18n.error_downloading_report,
              severity: "error",
            });
          }
          setIsLoading(false);
          return;
        }

        setIsLoading(false);
        showSnackbar({
          message: I18n.successfully_download_invoice,
          severity: "success",
        });
      },
      navigate,
      "Rupin Expense Bill",
    );
    triggerLogEvent(analytics, "exp_option_download");
  };
  const AccoountActions = [
    {
      label: (
        <Box display={"flex"} alignItems={"center"}>
          <Box marginRight={2}>
            <EditIcon width={20} height={20} />
          </Box>
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.edit}
          </ParagraphText>
        </Box>
      ),
      hideOnPaid: true,
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "exp_option_edit");
        onEdit();
      },
    },
    {
      label: (
        <Box display={"flex"} alignItems={"center"}>
          <Box marginRight={2} display={"flex"}>
            <DownloadIcon width={20} height={18} id="download_black_btn" />
          </Box>
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.download_bill}
          </ParagraphText>
        </Box>
      ),
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "exp_option_download");
        handleDownload();
      },
    },
    {
      label: (
        <ReceiptPage
          invoiceId={expense?.id ?? ""}
          isPrintIcon={false}
          isPrintBtn={false}
          handleDownloadLogEvent={() =>
            triggerLogEvent(analytics, "exp_receipt_download")
          }
          setIsReceiptLoading={setIsLoading}
          receiptFileName="Rupin Expense Receipt"
        />
      ),
      hideOnUnPaid: true,
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "exp_option_download");
      },
    },
    {
      label: (
        <Box display={"flex"} alignItems={"center"}>
          <Box marginRight={2} display={"flex"}>
            <BlackCheckIcon width={16} height={16} id="record_payment_btn" />
          </Box>
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.record_payment}
          </ParagraphText>
        </Box>
      ),
      hideOnPaid: true,
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "exp_option_record_payment");
        handleOpenRecordPaymentModal();
      },
    },
    {
      label: (
        <Box display={"flex"} alignItems={"center"}>
          <Box marginRight={2} display={"flex"}>
            <DeleteNewIcon width={20} height={18} id="download_black_btn" />
          </Box>
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.delete}
          </ParagraphText>
        </Box>
      ),
      action: (e) => {
        deletePrompt();
        e.stopPropagation();
      },
    },
  ];

  const deletePrompt = () => {
    setShowDeleteModal(true);
    return;
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    triggerLogEvent(analytics, "exp_option_delete");
    setShowDeleteModal(false);
    setIsActionLoading(true);

    if (orders.length) {
      let toDelete = [];
      await Promise.all(
        orders.map(async (item) => {
          let stock = await item.stock.fetch();

          toDelete.push({
            original: item,
            updated: stock,
          });
        }),
      );

      if (toDelete.length) {
        await bulkRestoreStock(toDelete, expense.type);
        await bulkDeleteOrders(toDelete);
        await bulkDeleteInventory(expense, toDelete, expense.type, "cash");
      }
    }
    if (customerDetail) {
      let payments = await expense.payment.fetch();
      await bulkDeletePaymentsV2(payments);

      let total = await calculateTotalOutstanding(customerDetail);
      await customerDetail.updateTotalOutstanding(total);
    }

    await expense.markAsDeleted();
    refetchList();
    setOpenDetailSidebar(false);
    setIsActionLoading(false);
    triggerLogEvent(analytics, "exp_deleted");
    Sync(user.phone_number, navigate);
    showSnackbar({
      message: I18n.transaction_deleted,
      severity: "success",
      icon: "",
    });
  };

  const handleSelectCustomer = async (customer) => {
    setSelectedCustomer(customer);
    setSelectedContactId(null);
  };

  const handleAddCustomer = async (customer) => {
    try {
      await expense.updateInvoiceCustomer(customer);

      if (expense?.status?.toLowerCase() != "paid") {
        const data = {
          amount: expense.amount,
          date: expense.transacted_at,
          image_url: expense.image_url,
          note: expense.note,
          advance_amount: expense.advance_amount || 0,
        };
        await handleCreateCustomerPayment(business, customer, data, expense);
      }

      setSearchQuery("");
      setSelectedCustomer("");
      Sync(user.phone_number, navigate);
      showSnackbar({
        message: I18n.contact_attached_successfully,
        severity: "success",
      });
    } catch (error) {
      await expense.updateInvoiceCustomer(null);
    }
  };
  const handleOpenRecordPaymentModal = () => {
    setIsOpenRecordPaymentModal(true);
  };

  const handleRecordPayment = (
    selectedMethod,
    selectedDate,
    receivedAmount,
  ) => {
    handleEditInvoice(
      Number(receivedAmount) + Number(expense.advance_amount),
      selectedMethod,
      selectedDate,
      customerDetail,
    );
  };

  const handleEditInvoice = async (
    amountRecvd,
    paymentMethod,
    transaction_date,
  ) => {
    setIsLoadingRecordPayment(true);
    triggerLogEvent(analytics, "exp_record");

    const invoiceAmountObj = {
      discount: expense?.discount || 0,
      discount_unit: expense?.discount_unit || "rs",
      tax_rate: expense?.tax_rate || 0,
      total: 0,
      sub_total: expense?.sub_total || 0,
      advance_amount: expense?.advance_amount || 0,
      profit: expense?.profit || 0,
    };

    let invoiceAmount = Number(expense?.amount) || 0;
    let invoiceStatus =
      invoiceAmount - (Number(amountRecvd) || 0) === 0 ? "paid" : "unpaid";
    let partialAmount = invoiceAmount - (Number(amountRecvd) || 0);
    const currentMethod = !paymentMethod ? expense?.method : paymentMethod;

    const fetchPaidTo = recordPaymentObj?.customer?.id
      ? await findCustomerByID(recordPaymentObj?.customer?.id)
      : null;

    const dataToEdit = {
      customer: recordPaymentObj?.customer?.id ? fetchPaidTo : null,
      recording_uri: expense?.recording_uri,
      advance_amount: Number(amountRecvd) || 0,
      invoice_number: expense?.invoice_number,
      invoice_prefix: expense?.invoice_prefix || business.invoice_number_prefix,
      invoice_title: expense?.invoice_title,
      discount_unit: expense?.discount_unit,
      sales_amount: expense?.sales_amount,
      document_url: expense?.document_url,
      cost_amount: expense?.cost_amount,
      attachment: expense?.attachment,
      sub_total: expense?.sub_total,
      signature: expense?.signature,
      tax_title: expense?.tax_title,
      image_url: expense?.image || null,
      date: transaction_date
        ? transaction_date
        : expense.transacted_at || new Date(),
      category: expense?.category,
      discount: expense?.discount,
      tax_rate: expense?.tax_rate,
      amount: invoiceAmount,
      method: currentMethod,
      wallet: currentMethod === "wallet" ? paymentMethod?.name : null,
      profit: expense?.profit,
      status: invoiceStatus,
      total: Number(invoiceAmountObj?.total) || 0,
      note: expense?.note || "",
      bank: currentMethod === "bank" ? paymentMethod?.name : null,
      partialAmount,
    };
    if (dataToEdit.customer && !addedCustomer) {
      const data = {
        amount: invoiceAmount,
        date: dataToEdit.date,
        image_url: dataToEdit.image_url,
        note: dataToEdit.note,
        advance_amount: dataToEdit.advance_amount,
      };
      await handleCreateCustomerPayment(
        business,
        dataToEdit.customer,
        data,
        expense,
      );
    } else if (dataToEdit.customer) {
      let dataForPayment = {
        udhaar_note: dataToEdit?.note,
        date: dataToEdit?.date || new Date(),
        image_url: dataToEdit?.image_url || null,
        invoiceDetail: expense,
        type: "cashbook",
      };
      // if total amount is changed wrt to current invoice, we will create or update invoice full payment entry
      if (invoiceAmount != expense?.amount) {
        dataForPayment["amount"] = invoiceAmount;
        let invoicePayment = await getPaymentsByInvoiceExternal(
          expense?.id,
          "full_invoice",
        );

        if (invoicePayment.length) {
          await invoicePayment[0]?.updatePayment(dataForPayment);
        } else {
          await dataToEdit.customer.createPayment({
            ...dataForPayment,
            uid: uuid(),
            date: new Date(),
            payment_mode: "Jama",
            external_type: "full_invoice",
          });
        }
      }
      if (
        Number(expense?.advance_amount) != Number(dataToEdit?.advance_amount)
      ) {
        // if received or partial amount is changed wrt to current invoice, we will create or update invoice partial payment entry

        dataForPayment["amount"] = Number(dataToEdit?.advance_amount);

        let invoicePayment = await getPaymentsByInvoiceExternal(
          expense?.id,
          "partial_invoice",
        );

        if (invoicePayment.length) {
          await invoicePayment[0]?.updatePayment(dataForPayment);
        } else {
          let payObj = {
            date: dataToEdit?.date || new Date(),
            note: dataToEdit?.note || "",
            image_url: dataToEdit?.image_url || "",
            type: "cashbook",
            uid: uuid(),
            amount: Number(dataToEdit.advance_amount),
            payment_mode: "Udhaar",
            external_type: "partial_invoice",
          };

          await bulkCreatePayments(business, dataToEdit.customer, expense, [
            payObj,
          ]);
        }
      }

      let totalOutstanding = await calculateTotalOutstanding(
        dataToEdit.customer,
      );

      await dataToEdit.customer.updateTotalOutstanding(totalOutstanding);
    }
    await expense.updateInvocie(dataToEdit);
    if (fetchPaidTo) triggerLogEvent(analytics, "exp_record_name");
    if (dataToEdit.advance_amount)
      triggerLogEvent(analytics, "exp_record_amount");
    if (dataToEdit.method) triggerLogEvent(analytics, "exp_record_method");
    setIsLoadingRecordPayment(false);
    setIsOpenRecordPaymentModal(false);
    setOpenDetailSidebar(false);
    refetchList();
    Sync(user?.phone_number, navigate);
    showSnackbar({
      message: I18n.update_record_sucessfully,
      severity: "success",
    });
  };

  const handleCreateCustomerPayment = async (
    business,
    customer,
    data,
    invoice,
  ) => {
    let payObj = {
      date: data?.date || new Date(),
      note: data?.note || "",
      image_url: data?.image_url || "",
      type: "cashbook",
    };

    let paymentArr = [
      {
        ...payObj,
        uid: uuid(),
        amount: data.amount,
        payment_mode: "Jama",
        external_type: "full_invoice",
      },
    ];

    if (data?.advance_amount > 0) {
      paymentArr.push({
        ...payObj,
        uid: uuid(),
        amount: Number(data.advance_amount),
        payment_mode: "Udhaar",
        external_type: "partial_invoice",
      });
    }

    await bulkCreatePayments(business, customer, invoice, paymentArr);

    let totalOutstanding = await calculateTotalOutstanding(customer);

    await customer.updateTotalOutstanding(totalOutstanding);
  };

  const handleEdit = () => {
    triggerLogEvent(analytics, "quick_expense_edit_btn");
    navigate(`/Expense/ExpenseForm/Edit/${expense.id}`);
  };

  let capitalizeMethod = expense["method"]
    ? capitalize(expense["method"]?.toString())
    : "";

  let capitalizeStatus = expense["status"]
    ? capitalize(expense["status"]?.toString())
    : "";

  const isPaid = capitalizeStatus
    ? capitalizeStatus === "Paid"
    : expense?.amount - (expense?.advance_amount || 0) <= 0;

  const balance = isPaid
    ? 0
    : Math.max(expense?.amount - (expense?.advance_amount || 0), 0);

  return (
    <Box
      id={`expence_list_${index}`}
      className="invoiceListTableBody AccountItemListWrapper"
      key={key}
      onClick={(e) => {
        if (
          showDeleteModal ||
          openDetailSidebar ||
          selectedCustomer ||
          isOpenRecordPaymentModal ||
          justClosedDropdownRef.current
        )
          return;
        e.stopPropagation();
        if (selectedContactId) {
          setSelectedContactId("");
          return;
        }
        setOpenDetailSidebar(true);
        triggerLogEvent(analytics, "exp_detail");
      }}
    >
      <Box className="invListTableHeaderCol sixColumn textLeft sidebarOption">
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {dateFormatInNumberWithSpace(expense?.transacted_at)}
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol sixColumn textLeft">
        <AddContactSelector
          selectedContact={
            customerDetail?.name
              ? { id: customerDetail?.id, name: customerDetail.name }
              : null
          }
          contacts={contactList || []}
          isOpen={selectedContactId === expense?.id}
          onOpenChange={(open) => {
            if (!customerDetail && !selectedContactId) {
              setSelectedContactId(open ? expense.id : "");
            } else if (selectedContactId) {
              justClosedDropdownRef.current = true;
              setSelectedContactId("");
              setTimeout(() => {
                justClosedDropdownRef.current = false;
              }, 100);
            } else if (!selectedContactId && !justClosedDropdownRef.current) {
              setOpenDetailSidebar(true);
            }
          }}
          onSelect={handleSelectCustomer}
          addContactLabel={I18n.add_contact || "Add contact"}
          searchPlaceholder={I18n.search_contact || "Search contact"}
          contactType="out"
        />
      </Box>
      <Box className="invListTableHeaderCol sixColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor displayFlex">
          {(() => {
            // Display only: status/method are stored in English and drive isPaid above, so translate here
            const statusText = capitalizeStatus || (isPaid ? "Paid" : "Unpaid");
            const statusLabel = capitalize(I18n[statusText.toLowerCase()] || statusText);
            const methodLabel = capitalizeMethod
              ? capitalize(I18n[String(expense["method"]).toLowerCase()] || capitalizeMethod)
              : "";
            const methodText = methodLabel ? `/ ${methodLabel}` : "";
            return `${statusLabel} ${methodText}`.trim();
          })()}
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol sixColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {expense?.category
            ? resolveCategoryDisplayName(
                expense.type === "in" ? "business_sale" : "business_expense",
                expense.category,
              )
            : "-"}
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol sixColumn textRight amountColumnNewWrapper">
        <ListTableAmountCell
          showAction={!isPaid && EMIVerified }
          actionLoading={isAccountLoading && selectedId === expense?.id}
          actionDisabled={isAccountLoading}
          onActionClick={() => {
            if (justClosedDropdownRef.current) {
              return;
            }
            handleSendMoney(expense, customerDetail);
          }}
          buttonClassName={amountCellStyles.sendMoneyButton}
          buttonTitle={sentenceCase(I18n.send_money)}
          buttonTitleStyle={{
            fontSize: 11,
            fontWeight: 400,
            color: "var(--textPrimary)",
          }}
          amountWrapperClassName={
            isPaid ? "newFontColor" : "foundationGreenColor"
          }
        >
          {isPaid && (expense?.amount < 0 ? "+" : "-")}Rs.{" "}
          {formatNum(Math.abs(expense.amount) || 0)}
        </ListTableAmountCell>
      </Box>

      <Box
        className={`invListTableHeaderCol sevenColumn textRight sidebarOption`}
      >
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textRight newFontColor">
          Rs. {formatNum(balance)}
        </ParagraphText>
      </Box>

      <Box className="amountColumnInnerWrapper invListTableHeaderCol sixColumn textCenter">
        <ParagraphText className="fontSize14 fontWeight400 textCenter newFontColor tableActionsCell">
          <div className="tblOptnBox" role="button">
            <PopoverMenu
              id="expence"
              menuOptions={AccoountActions.filter((acts) => {
                const status = expense?.status?.toLowerCase();

                if (status === "paid" && acts?.hideOnPaid) {
                  return false;
                }

                if ((status === "unpaid" || !status) && acts?.hideOnUnPaid) {
                  return false;
                }

                return true;
              })}
              popOverStyle={{
                marginLeft: "5px",
                borderRadius: "16px !important",
              }}
              popoverButton={
                (isLoading || isActionLoading) && (
                  <CircularProgress size={"15px"} />
                )
              }
              disabled={isLoading || isActionLoading}
            />
          </div>
        </ParagraphText>
      </Box>

      {openDetailSidebar ? (
        <SidebarBodyContent
          onClose={() => setOpenDetailSidebar(false)}
          open={openDetailSidebar}
          quickSale={expense}
          refetchList={refetchList}
          business={business}
          handleDelete={() => setShowDeleteModal(true)}
          handleMarkAsPaid={() => {
            triggerLogEvent(analytics, "quick_expense_side_bar_mark_paid");
            handleOpenRecordPaymentModal();
          }}
          handleEdit={handleEdit}
          invoiceBtnTitle={I18n.download_bill}
          unpaidAmountVariant="expense"
          invoiceFileName="Rupin Expense Bill"
        />
      ) : null}

      {showDeleteModal && (
        <ConfirmationModal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleDelete}
          title={I18n.this_action_cannot_be_undone}
          message={I18n.are_you_sure_you_want_to_delete_transaction}
          confirmText={I18n.delete}
          id="delete_exp_modal"
        />
      )}

      {selectedCustomer && (
        <ConfirmationModal
          open={Boolean(selectedCustomer)}
          onClose={() => setSelectedCustomer("")}
          confirmButtonClassName="ubPrimaryButton"
          onConfirm={() => handleAddCustomer(selectedCustomer)}
          title={I18n.you_wont_be_able_to_change_it_later}
          htmlMessage={
            <AttachContactMessage name={selectedCustomer.name} />
          }
          confirmText={I18n.confirm}
          id="quick_sale_add_contact_cofirm_modal"
        />
      )}

      {isOpenRecordPaymentModal ? (
        <Box onClick={(e) => e.stopPropagation()}>
          <RecordPaymentModal
            handleConfirm={handleRecordPayment}
            handleClose={() => setIsOpenRecordPaymentModal(false)}
            isOpen={isOpenRecordPaymentModal}
            title={I18n.record_payment}
            selectedInvoice={expense}
          />
        </Box>
      ) : null}

      <div style={{ display: "none" }}>
        <div ref={componentRef}>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
      </div>
    </Box>
  );
};

const enhance = withObservables(
  ["expense", "business"],
  ({ expense, business }) => ({
    customerDetail: expense?.customer
      ? expense.customer.observe().pipe(catchError(() => of(null)))
      : of(null),
    orders: expense.orders.observe(),
  }),
);

export default enhance(ItemList);
